import { prop } from "../../decorators/property";

export class WelcomeListItemModel extends Backbone.AssociatedModel {

    @prop() public Options: any;
    @prop() public Query?: string;
    @prop() public Title?: string;
    @prop() public Court?: string;
    @prop() public DocKey?: string;
    @prop() public Year?: number;
    @prop() public Url?: string;
    @prop() public Flag?: string;
    @prop() public DisplayJurisdiction?: string;
    @prop() public Categories?: string[];

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/welcome-list-item.ts